import Holidays from 'date-holidays';
import { getDay } from 'date-fns';

// Inicializar con festivos de España
const hd = new Holidays('ES');

// Función para verificar si una fecha es festivo
export const isHoliday = (date) => {
  const holidays = hd.isHoliday(date);
  if (!holidays) return false;

  // Filtrar para incluir solo festivos públicos (excluir observances y sustitutos opcionales)
  // Si quieres incluir los días sustitutos, cambia esto a: return holidays !== false;
  const publicHolidays = holidays.filter(h => h.type === 'public');
  return publicHolidays.length > 0;
};

// Función para obtener el nombre del festivo
export const getHolidayName = (date) => {
  const holidays = hd.isHoliday(date);
  if (holidays && holidays.length > 0) {
    return holidays[0].name;
  }
  return null;
};

// Función para verificar si es fin de semana
export const isWeekend = (date) => {
  const day = getDay(date);
  return day === 0 || day === 6; // 0 = Domingo, 6 = Sábado
};

// Función para obtener todos los festivos de un año
export const getHolidaysForYear = (year) => {
  return hd.getHolidays(year);
};

// Función para verificar si es sábado
export const isSaturday = (date) => {
  return getDay(date) === 6;
};

// Función para verificar si es domingo
export const isSunday = (date) => {
  return getDay(date) === 0;
};

// Función para obtener la clase CSS según el tipo de día
export const getDayClass = (date) => {
  if (isHoliday(date)) {
    return 'holiday';
  }
  if (isSaturday(date)) {
    return 'saturday';
  }
  if (isSunday(date)) {
    return 'sunday';
  }
  return '';
};
